<template>
  <router-view v-slot="{Component}">
    <transition name="fade" mode="out-in">
      <component :is="Component"/>
    </transition>
  </router-view>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
body {
  background: none !important;
}

#wrapper {
  position: relative;
}
.recommend td{background:#003f2d !important;color:#fff}
</style>